import Organize from '../../src/legacy/Organize.tsx';
export default Organize;
